import {SnapshotTheme} from "./digitalSigning.types";

/*
    How the guest page shows the design's photo, cut to 16:9 on upload: Hero's banner shows it whole,
    Background covers the page with it, centered.
*/

/** Background's photo when the snapshot names no opacity: Medium, the backend's default. */
export const DEFAULT_HERO_OPACITY = 45;

/** The white card's widest (SigningShell: the 600 px column and its padding). */
const BANNER_MAX_WIDTH = 664;

/**
 * Hero's banner: the photo whole at 16:9 - the upload's cut, so nothing more is cropped - and at most
 * 40 % of the screen's height, so a landscape tablet still shows the title and the details on its first
 * screen. Across a phone's screen; from a tablet up it sits in the band like the card below it: at most
 * as wide, with its corners.
 */
export const HERO_BANNER_SX = {
    width: {
        xs: 'min(100%, calc(40vh * 16 / 9))',
        sm: `min(100% - 48px, ${BANNER_MAX_WIDTH}px, calc(40vh * 16 / 9))`,
    },
    aspectRatio: '16 / 9',
    mx: 'auto',
    mt: {xs: 0, sm: 3},
};

const clampPercent = (value: unknown, fallback: number): number => (
    typeof value === 'number' && Number.isFinite(value) ? Math.min(100, Math.max(0, value)) : fallback
);

/** Background's photo opacity as a CSS opacity (0.45 for 45 %). */
export const photoOpacity = (theme?: SnapshotTheme): number => clampPercent(theme?.heroOpacity, DEFAULT_HERO_OPACITY) / 100;
